import React from 'react';

// The same array instance for as long as every item is the same, so a memo can key on a list
// the render rebuilds (such as each query's data) rather than recompute every render. Kept as
// state derived during render, the pattern React documents for remembering a previous render.
export function useStableArray<T>(items: T[]): T[] {
  const [stable, setStable] = React.useState(items);
  if (stable.length !== items.length || items.some((item, index) => item !== stable[index])) {
    setStable(items);
    return items;
  }
  return stable;
}
